export default __webpack_public_path__ + "static/media/sim-cards.9dd461c1.svg";